'use strict'
import data from './data'
export default {
  name: 'videoList',
  data () {
    return {
      listId: 0,
      videoListInfo: []
    }
  },
  mounted () {
    this.listId = this.$route.query.id
    this.videoListInfo = data()[this.listId]
  },
  methods: {
    jumpToVideo (event, obj) {
      this.$router.push(`/viewVideo?id=${obj.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/videoList/videoList.js